import { useState } from "react";
import { Box } from "@mui/material";

import { t } from "i18next";

import { LinkStyleButton } from "../HotelCancelPolicy";
import { RemarksModal } from "./modal";
import { Info } from "@mui/icons-material";

type Props = {
  remarks: string;
}

export const HotelFareRemarks = ({ remarks }: Props) => { 
  const [modalOpen, setModalOpen] = useState(false);
  return (
    <>
      <RemarksModal open={modalOpen} onClose={() => setModalOpen(false)} remarks={remarks} />
      <Box display="flex" alignItems="center" justifyContent="flex-end" gap={1}>
        <Info color="warning"/> 
        <LinkStyleButton onClick={() => setModalOpen(prev => !prev)} sx={{ flex: 1}}>
          { t('hotels.fares.remarks') }
        </LinkStyleButton>
      </Box>
    </>
  );
}
